import { render, staticRenderFns } from "./PacientesDetalleGarantias.vue?vue&type=template&id=490a4eee&"
import script from "./PacientesDetalleGarantias.vue?vue&type=script&lang=js&"
export * from "./PacientesDetalleGarantias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports